let authRoutes = [
    {
		path: '/signin',
		name: 'SignIn',
        meta: {
            requiresAuth: false,
            allowAuthenticated: false,
            title: 'Signin | Appointment Portal RDCD',        
            displayTitle: 'Sign In',
            layoutClass: 'layout-sign-up',
        },
		component: () => import(/* webpackChunkName: 'auth' */ '../pages/SignInPage.vue'),
	},
    // {
	// 	path: '/appointments/apply',
	// 	name: 'Apply',
	// 	meta: {
	// 		requiresAuth: false,
    //         allowAuthenticated: false,
    //         title: 'Apply for Appointment | Appointment Portal RDCD',        
    //         displayTitle: 'Apply',
    //         layoutClass: 'layout-sign-up',
	// 	},
	// 	component: () => import('../pages/ApplyPage.vue'),
	// },
	{
		path: '/appointments/apply',
		name: 'Apply',
		meta: {
			requiresAuth: false,
            allowAuthenticated: false,
            title: 'Apply for Appointment | Appointment Portal RDCD',        
            displayTitle: 'Apply',
            layoutClass: 'layout-sign-up',
		},
		component: () => import(/* webpackChunkName: 'auth' */'../pages/ApplyPageRDCD.vue'),
	},
    {
		path: '/forgot-password',
		name: 'ForgotPassword',
		meta: {
			requiresAuth: false,
            allowAuthenticated: false,
            title: 'Forgot Password | Appointment Portal RDCD',        
            displayTitle: 'forgot-password',
            layoutClass: 'layout-sign-up',
		},
		component: () => import(/* webpackChunkName: 'auth' */'../pages/ForgetPasswordPage.vue'),
	},
    {
		path: '/reset-password',
		name: 'ResetPassword',
		meta: {
			requiresAuth: false,
            allowAuthenticated: false,
            title: 'Reset Password | Appointment Portal RDCD',        
            displayTitle: 'reset-password',
            layoutClass: 'layout-sign-up',
		},
		component: () => import(/* webpackChunkName: 'auth' */'../pages/PasswordResetPage.vue'),
	},
];
export { authRoutes };